// React 19 native metadata

const SEO_CONFIG = {
  default: {
    title: 'iSupplyAI — AI Marketing Agents That Argue Strategy',
    description: 'Summon a council of AI marketing strategists. They analyze competitors, create content, find leads, and debate strategy for your business.',
  },
  dashboard: {
    title: 'Dashboard | iSupplyAI',
    description: 'Manage your AI-powered content generation, track performance, and monitor your marketing agents.',
  },
  agents: {
    title: 'AI Marketing Agents | iSupplyAI',
    description: 'Hire AI agents: Athena for competitive intelligence, Hermes for content creation, Apollo for distribution, and more.',
  },
  artemis: {
    title: 'Artemis Lead Hunter | iSupplyAI',
    description: 'AI-powered lead generation. Find high-intent prospects on Reddit, Twitter, and the web. Nurture and convert.',
  },
  generate: {
    title: 'AI Content Generator | iSupplyAI',
    description: 'Generate blog posts, social media content, SEO articles, and more with AI. Multiple tones, languages, and formats.',
  },
  multiply: {
    title: 'Content Multiplier | iSupplyAI',
    description: 'Transform one piece of content into five platform-ready versions. LinkedIn, Twitter, Facebook, Instagram, and Medium.',
  },
  seo: {
    title: 'SEO Optimizer | iSupplyAI',
    description: 'AI-powered SEO analysis and content optimization. Keyword suggestions, readability scoring, and search ranking insights.',
  },
  performance: {
    title: 'Performance Predictor | iSupplyAI',
    description: 'Predict content engagement before you publish. AI-powered forecasting for clicks, shares, and conversions.',
  },
  trending: {
    title: 'Trending Topics | iSupplyAI',
    description: 'Discover trending topics in your industry. Real-time data on what your audience is talking about right now.',
  },
  viral: {
    title: 'Viral Content Analyzer | iSupplyAI',
    description: 'Analyze what makes content go viral. Get AI-powered insights on engagement patterns and shareability.',
  },
  referrals: {
    title: 'Referral Program | iSupplyAI',
    description: 'Earn credits by referring others to iSupplyAI. Share your unique link and get rewarded.',
  },
};

const PageSEO = ({ page }) => {
  const config = SEO_CONFIG[page] || SEO_CONFIG.default;

  return (
    <>
      <title>{config.title}</title>
      <meta name="description" content={config.description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="iSupplyAI" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:title" content={config.title} />
      <meta property="og:description" content={config.description} />
      <meta property="og:image" content="https://customer-assets.emergentagent.com/job_procontentai/artifacts/8fc8dhxn_ISupplyAILogo%238.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@isupplyai" />
      <meta name="twitter:creator" content="@isupplyai" />
      <meta name="twitter:title" content={config.title} />
      <meta name="twitter:description" content={config.description} />
      <meta name="twitter:image" content="https://customer-assets.emergentagent.com/job_procontentai/artifacts/8fc8dhxn_ISupplyAILogo%238.png" />
    </>
  );
};

export default PageSEO;
export { SEO_CONFIG };
